module.exports = __webpack_public_path__ + "media/recipes/18-dc4a6cd4.png";